import CardActionArea from '@material-ui/core/CardActionArea';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import { getStatusLabel, IStatusMetrics, statusesColors } from 'interfaces/dashboard';
import CircleIcon from 'mdi-react/CircleIcon';
import React, { memo } from 'react';
import { Cell, Label, Pie, PieChart, Tooltip } from 'recharts';
import { percentage } from '../../../../../helpers/number';

import Card from '../Component/Card';

interface IProps {
  entityName: string;
  metrics: IStatusMetrics[];
  total: number;
  onClick: () => void;
}

const useStyles = makeStyles(theme => ({
  actionArea: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
  },
  content: {
    alignSelf: 'center'
  },
  middleText: theme.typography.subtitle2,
  text: {
    textTransform: 'initial',
    lineHeight: 1.5,
  },
  center: {
    justifyContent: 'center',
    display: 'flex',
  },
  iconStatus: {
    verticalAlign: 'middle',
  },
  tooltipPaper: {
    padding: '4px 8px',
  },
  graph: {
    width: '100px',
    height: '100px',
  }
}));

const CustomTooltip = (props: any) => {
  const { active, payload, classes } = props;
  if (active && payload && payload.length) {
    return (
      <Paper className={clsx('recharts-default-tooltip', classes.tooltipPaper)}>
        <Typography noWrap variant='caption' >
          {payload[0].name !== 'NO_DOCUMENTS'
            ? (
              <>
                <CircleIcon size={11} color={statusesColors[payload[0].name]} className={classes.iconStatus} />{' '}
                {getStatusLabel(payload[0].name, true) + ': ' + payload[0].value}
              </>
            )
            : getStatusLabel(payload[0].name, true)}
        </Typography>
      </Paper>
    );
  }

  return null;
};

const Statuses = memo<IProps>((props) => {
  const classes = useStyles();
  const { entityName, metrics, onClick, total } = props;
  const totalRated = metrics.reduce((acc, c) => acc + c.value, 0);
  const totalRatedPercentage = percentage(totalRated, total);

  const getMetrics = () => {
    return totalRated > 0 ? metrics : [{
      value: 1,
      status: 'NO_DOCUMENTS'
    }];
  };

  return (
    <CardActionArea onClick={onClick} className={classes.actionArea}>
      <Card bgContent>
        <Grid container>
          <Grid item xs={6} className={classes.center}>
            <PieChart width={70} height={70}>
              <Pie
                data={getMetrics()}
                dataKey="value"
                nameKey="status"
                innerRadius={25}
                outerRadius={35}
                startAngle={90}
                endAngle={-270}
              >
                <Label
                  className={classes.middleText}
                  value={totalRatedPercentage}
                  position="center"
                  style={{ fontWeight: 'bold', fontSize: '18px' }}
                />

                {totalRated > 0 && metrics.map((m) => (
                  <Cell key={`cell-${m.status}`} fill={statusesColors[m.status]} />
                ))}

                {totalRated === 0 && (<Cell fill={'#E0E2E3'} />)}
              </Pie>
              <Tooltip content={(props: any) => <CustomTooltip {...props} classes={classes} />} />
            </PieChart>
          </Grid>

          <Grid item xs={6} className={classes.content}>
            <Typography align="center" variant="h4" style={{ fontSize: '16px' }}>
              <strong>{totalRated}</strong>
            </Typography>
            <Typography
              align="center"
              variant='overline'
              color='textSecondary'
              className={classes.text}
              component='div'
            >
              Documentos
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography align="center" variant='body2' style={{ fontWeight: 'bold' }}>{entityName}</Typography>
          </Grid>
        </Grid>

      </Card>
    </CardActionArea>
  );
});

export default Statuses;